import { useDispatch, useSelector } from 'react-redux';
import { IoArrowBackOutline, IoArrowForwardOutline } from 'react-icons/io5';
import { setCurrentPage } from '../store/slice/paginationSlice';

const Pagination = ({ totalEntries }) => {
  const dispatch = useDispatch();
  const { currentPage, entriesPerPage } = useSelector(state => state.pagination);

  const totalPages = Math.ceil(totalEntries / entriesPerPage);

  const handlePreviousPage = () => {
    if (currentPage > 1) {
      dispatch(setCurrentPage(currentPage - 1));
    }
  };

  const handleNextPage = () => {
    if (currentPage < totalPages) {
      dispatch(setCurrentPage(currentPage + 1));
    }
  };

  return (
    <div className="flex items-center justify-between px-4 py-3 sm:px-6 font-nohemi">
      <p className="text-sm text-gray-500">
        Showing <span className="font-light">{(currentPage - 1) * entriesPerPage + 1}</span> to{' '}
        <span className="font-light">{Math.min(currentPage * entriesPerPage, totalEntries)}</span>{' '}
        of <span className="font-light">{totalEntries}</span> entries
      </p>

      {/* Pagination Controls */}
      <nav className="inline-flex space-x-1 rounded-md isolate" aria-label="Pagination">
        {/* Previous Button */}
        <button
          onClick={handlePreviousPage}
          className="flex items-center justify-center w-6 h-6 text-gray-400 rounded-full ring-1 ring-inset ring-gray-300 bg-gray-50 focus:z-20 focus:outline-offset-0"
          disabled={currentPage === 1}>
          <IoArrowBackOutline />
        </button>

        {/* Page Buttons */}
        {[...Array(totalPages).keys()].map(page => (
          <button
            key={page}
            onClick={() => dispatch(setCurrentPage(page + 1))}
            className={`flex items-center justify-center w-6 h-6 rounded-full text-sm font-medium ${
              currentPage === page + 1 ? 'bg-black text-white' : 'text-gray-900'
            } focus:z-20`}>
            {page + 1}
          </button>
        ))}

        {/* Next Button */}
        <button
          onClick={handleNextPage}
          className="flex items-center justify-center w-6 h-6 text-gray-400 rounded-full ring-1 ring-inset ring-gray-300 bg-gray-50 focus:z-20 focus:outline-offset-0"
          disabled={currentPage === totalPages}>
          <IoArrowForwardOutline />
        </button>
      </nav>
    </div>
  );
};

export default Pagination;
